module.exports = __webpack_public_path__ + "assets/img/head.3a686c8c.png";